import Blockly from 'blockly/core';
export const customTheme = Blockly.Theme.defineTheme('modest', {
    categoryStyles: {
        "object_category": {
            "colour": "#6D83B2" // A muted blue
        },
        "dataset_category": {
            "colour": "#6D83B2" // A muted blue
        },
        "custom_category": {
            "colour": "#B2A061" // A muted gold
        },
        "logic_category": {
            "colour": "#A8B3C5" // A muted purple
        },
        "math_category": {
            "colour": "#A3C1AD" // A muted green
        },
        "loop_category": {
            "colour": "#8CB26D" // A muted green
        },
        "text_category": {
            "colour": "#B28C6D" // A muted brown
        },
        "list_category": {
            "colour": "#6DB2A0" // A muted teal
        },
        "colour_category": {
            "colour": "#B26D8C" // A muted pink
        },
        "variable_category": {
            "colour": "#8CB26D" // A muted green
        },
        "variable_dynamic_category": {
            "colour": "#B28C6D" // A muted brown
        },
        "procedure_category": {
            "colour": "#6D6DB2" // A muted indigo
        }
    },
    blockStyles: {
        object_blocks: {
            colourPrimary: '#B26D6D', // A muted red
            colourSecondary: '#D3A3A3', // A lighter, desaturated red
            colorTertiary: '#804A4A', // A darker, desaturated red
        },
        dataset_blocks: {
            colourPrimary: '#6D83B2', // A muted blue
            colourSecondary: '#A3B4C6', // A lighter, desaturated blue
            colorTertiary: '#4A5A80', // A darker, desaturated blue
        },
        custom_blocks: {
            colourPrimary: '#B2A061', // A muted gold
            colourSecondary: '#D3C28B', // A lighter, desaturated gold
            colorTertiary: '#91834D', // A darker, desaturated gold
        },
        logic_blocks: {
            colourPrimary: '#A8B3C5', // A muted purple
            colourSecondary: '#D3D6E1', // A lighter, desaturated purple
            colorTertiary: '#7F8BA9', // A darker, desaturated purple
        },
        math_blocks: {
            colourPrimary: '#A3C1AD', // A muted green
            colourSecondary: '#D3DDD6', // A lighter, desaturated green
            colorTertiary: '#7FA98F', // A darker, desaturated green
        },
        loop_blocks: {
            colourPrimary: '#8CB26D', // A muted green
            colourSecondary: '#B9D3A3', // A lighter, desaturated green
            colorTertiary: '#6F804A', // A darker, desaturated green
        },
        text_blocks: {
            colourPrimary: '#B28C6D', // A muted brown
            colourSecondary: '#D3B9A3', // A lighter, desaturated brown
            colorTertiary: '#806F4A', // A darker, desaturated brown
        },
        list_blocks: {
            colourPrimary: '#6DB2A0', // A muted teal
            colourSecondary: '#A3D3C6', // A lighter, desaturated teal
            colorTertiary: '#4A806E', // A darker, desaturated teal
        },
        colour_blocks: {
            colourPrimary: '#B26D8C', // A muted pink
            colourSecondary: '#D3A3B9', // A lighter, desaturated pink
            colorTertiary: '#804A6F', // A darker, desaturated pink
        },
        variable_blocks: {
            colourPrimary: '#8CB26D', // A muted green
            colourSecondary: '#B9D3A3', // A lighter, desaturated green
            colorTertiary: '#6F804A', // A darker, desaturated green
        },
        variable_dynamic_blocks: {
            colourPrimary: '#B28C6D', // A muted brown
            colourSecondary: '#D3B9A3', // A lighter, desaturated brown
            colorTertiary: '#806F4A', // A darker, desaturated brown
        },
        procedure_blocks: {
            colourPrimary: '#6D6DB2', // A muted indigo
            colourSecondary: '#A3A3D3', // A lighter, desaturated indigo
            colorTertiary: '#4A4A80', // A darker, desaturated indigo
        },
    },
});